'use es6';

import { useSelector } from 'react-redux';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { currentSkuIdForProductSelector, parcelNameToProductIdSelector, productForSkuIdSelector, productVersionSelector, skuIdIsHubSelector, skuSelector } from '../../selectors/ProductsSelectors';
import { productDataSelector } from '../../selectors/SelectorUtils';
import { useQueryParamsEffect } from '../../utils/queryParamUtils';
export const queryParamProductConfigurationsSelector = (state, {
  queryParams
}) => {
  const productConfigurations = [];
  const {
    products,
    packs
  } = queryParams;
  const {
    apiNameToProductId
  } = productDataSelector(state);
  const stringProductConfigs = products ? typeof products === 'string' ? [products] : products : [];
  const stringQuantityPacks = packs ? typeof packs === 'string' ? [packs] : packs : [];

  const validatedQuantity = split => split.length > 1 ? Number(split[1]) : 1;

  stringProductConfigs.forEach(entry => {
    const split = entry.toString().split('_');

    if (split.length > 0) {
      const apiName = split[0];
      const quantity = validatedQuantity(split);

      if (apiName in apiNameToProductId) {
        productConfigurations.push(createProductConfig({
          skuId: currentSkuIdForProductSelector(state, {
            apiName
          }),
          quantity
        }));
      }
    }
  });
  stringQuantityPacks.forEach(entry => {
    const split = entry.toString().split('_');

    if (split.length > 0) {
      const parcelNameToProductId = parcelNameToProductIdSelector(state);
      const parcelName = split[0];

      if (parcelName in parcelNameToProductId) {
        const currentProductVersionSkuId = currentSkuIdForProductSelector(state, {
          productId: parcelNameToProductId[parcelName]
        });
        const {
          quantityPackDetails
        } = productVersionSelector(state, {
          skuId: currentProductVersionSkuId
        });
        const quantityPack = quantityPackDetails.find(({
          parcelName: searchParcelName
        }) => parcelName === searchParcelName);

        if (quantityPack) {
          const {
            skuId
          } = quantityPack;
          const quantity = validatedQuantity(split);
          productConfigurations.push({
            skuId,
            quantity
          });
        }
      }
    }
  });
  return productConfigurations;
};
export const useQueryParamProductConfigsOrDefault = ({
  defaultConfigurations,
  requiredProductLines
}) => {
  const queryParams = getQueryParams();
  const queryParamProductConfigurations = useSelector(state => hasPricingAndPurchasingSucceededSelector(state) && queryParamProductConfigurationsSelector(state, {
    queryParams
  }));
  const isMissingRequiredProductLine = useSelector(state => requiredProductLines.some(productLine => queryParamProductConfigurations.every(({
    skuId
  }) => {
    const isHub = skuIdIsHubSelector(state, {
      skuId
    });
    const {
      productLine: searchProductLine
    } = productForSkuIdSelector(state, {
      skuId
    });
    return productLine !== searchProductLine || !isHub;
  })));

  if (!queryParamProductConfigurations.length || isMissingRequiredProductLine) {
    return [...defaultConfigurations.filter(({
      skuId
    }) => queryParamProductConfigurations.every(({
      skuId: querySkuId
    }) => skuId !== querySkuId)), ...queryParamProductConfigurations];
  }

  return queryParamProductConfigurations;
};
export const useProductConfigsQueryParamsParamsEffect = productConfigurations => {
  const {
    products,
    packs
  } = useSelector(state => {
    const tempProducts = [];
    const tempPacks = [];
    productConfigurations.forEach(({
      skuId,
      quantity
    }) => {
      const sku = skuSelector(state, {
        skuId
      });

      if (sku.skuType === QUANTITY_PACK) {
        tempPacks.push(`${sku.parcelName}_${quantity}`);
      } else {
        const {
          apiName
        } = productForSkuIdSelector(state, {
          skuId
        });
        tempProducts.push(`${apiName}_${quantity}`);
      }
    });
    return {
      products: tempProducts,
      packs: tempPacks
    };
  });
  useQueryParamsEffect({
    products,
    packs
  });
};